import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class InvalidApplicationException extends LicenseException
{
  
}
